import api from './api.js';

export const examService = {
  // Get all exams for current user
  getExams: (params = {}) => api.get('/exams', { params }),
  
  // Get exam by ID
  getExam: (id) => api.get(`/exams/${id}`),
  
  // Create new exam (teacher only)
  createExam: (data) => api.post('/exams', data),
  
  // Update exam (teacher only)
  updateExam: (id, data) => api.put(`/exams/${id}`, data),
  
  // Delete exam (teacher only)
  deleteExam: (id) => api.delete(`/exams/${id}`),
  
  // Schedule exam (teacher only)
  scheduleExam: (id, data) => api.post(`/exams/${id}/schedule`, data),
  
  // Get exam results
  getExamResults: (examId) => api.get(`/exams/${examId}/results`),
  
  // Get my exam results (student only)
  getMyExamResults: (params = {}) => api.get('/exams/results', { params }),
  
  // Get exam result by ID
  getExamResult: (examId, resultId) => api.get(`/exams/${examId}/results/${resultId}`),
  
  // Start exam (student only)
  startExam: (examId) => api.post(`/exams/${examId}/start`),
  
  // Submit exam answers (student only)
  submitExamAnswers: (examId, data) => api.post(`/exams/${examId}/submit`, data),
  
  // Enter exam results (teacher only)
  enterExamResults: (examId, data) => api.post(`/exams/${examId}/results`, data),
  
  // Update exam result (teacher only)
  updateExamResult: (examId, resultId, data) => 
    api.put(`/exams/${examId}/results/${resultId}`, data),
  
  // Get exams by class (teacher only)
  getExamsByClass: (classId, params = {}) => 
    api.get(`/exams/class/${classId}`, { params }),
  
  // Get upcoming exams
  getUpcomingExams: (params = {}) => api.get('/exams/upcoming', { params }),
  
  // Get past exams
  getPastExams: (params = {}) => api.get('/exams/past', { params }),
  
  // Get exam statistics (teacher only)
  getExamStats: (examId) => api.get(`/exams/${examId}/stats`),
  
  // Get exam analytics (teacher only)
  getExamAnalytics: (examId) => api.get(`/exams/${examId}/analytics`),
  
  // Bulk enter results (teacher only)
  bulkEnterResults: (examId, data) => api.post(`/exams/${examId}/bulk-results`, data),
  
  // Export exam results (teacher only)
  exportResults: (examId) => api.get(`/exams/${examId}/export-results`, { responseType: 'blob' }),
  
  // Get exam questions (if applicable)
  getExamQuestions: (examId) => api.get(`/exams/${examId}/questions`),
  
  // Save exam progress (student only)
  saveExamProgress: (examId, data) => api.post(`/exams/${examId}/save-progress`, data),
  
  // Get exam progress (student only)
  getExamProgress: (examId) => api.get(`/exams/${examId}/progress`),
};
